<template>
  <vbt-dialog
    hide-submit-btn
    title="Design Links"
  >
    <template #activator="{ on }">
      <v-blacker-button
        small
        outlined
        color="info"
        v-on="on"
      >
        Show design links
      </v-blacker-button>
    </template>

    <v-layout
      id="designLinksLayout"
      :class="{
        'white--text': $vuetify.theme.dark
      }"
      column
    >
      <v-layout
        v-for="(link, i) in links"
        :key="i"
      >
        <span class="mr-1">
          {{ i + 1 }}.
        </span>

        <a
          :href="link"
          class="blue--text"
          target="_blank"
        >
          {{ link }}
        </a>

        <v-btn
          icon
          x-small
          class="mx-1"
          @click="copyLink(link)"
        >
          <v-icon
            small
            color="info"
          >
            content_copy
          </v-icon>
        </v-btn>
      </v-layout>
    </v-layout>
  </vbt-dialog>
</template>

<script>
import { copyToClipboard } from '@helpers';

export default {
  name: 'JobDesignLinksViewer',

  props: {
    links: {
      type: Array,
      required: true,
    },
  },

  methods: {
    copyLink(link) {
      copyToClipboard(link, 'linksLayout');
    },
  },
};
</script>
